import { mode, transparentize } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { theme } = props;
    return {
        color: mode(transparentize('gray.500', 0.67)(theme), transparentize('white', 0.7)(theme))(props),
        borderRadius: 'base',
        transition: 'all 0.25s',
        background: mode('gray.100', 'gray.550')(props),
        _hover: {
            background: mode('gray.150', 'gray.500')(props),
        },
        _active: {
            bg: mode('blue.500', 'blue.300')(props),
            color: mode('white', transparentize('black', 0.87)(theme))(props),
        },
        _focus: {
            position: 'relative',
            zIndex: 1,
            outline: 'none',
            boxShadow: mode(`0 0 0 1px ${transparentize('blue.600', 1.0)(props.theme)}, 0 0 0 5px ${transparentize('blue.400', 0.24)(props.theme)}`, `0 0 0 1px ${transparentize('blue.300', 1.0)(props.theme)}, 0 0 0 5px ${transparentize('blue.400', 0.24)(props.theme)}`)(props),
        },
        ':focus:not(:focus-visible)': {
            boxShadow: 'none',
        },
        ':focus:not(:-moz-focusring)': {
            boxShadow: 'none',
        },
        _disabled: {
            cursor: 'not-allowed',
            color: mode(transparentize('gray.500', 0.24)(theme), transparentize('white', 0.35)(theme))(props),
            background: mode(transparentize('gray.300', 0.16)(theme), transparentize('blue.100', 0.08)(theme))(props),
        },
    };
};
const sizes = {
    sm: {
        h: '1.75rem',
        minW: '2.75rem',
        fontSize: 'sm',
    },
};
const defaultProps = {
    size: 'sm',
};
export default {
    baseStyle: getBaseStyle,
    sizes,
    defaultProps,
};
//# sourceMappingURL=toolbar-button.js.map